/**
 * get directrion string
 * from boolean
 * @param rtl
 */
export const directionFromRtl = (rtl?: boolean): 'ltr' | 'rtl' =>
  rtl ? 'rtl' : 'ltr';

/**
 * get rtl from directrion
 * @param directrion
 */
export const rtlFromDirection = (directrion?: string): boolean =>
  directrion === 'rtl';
